query ApprovalAvailableTags($id: UUID!) {
  approvalAvailableTags(entityId: $id) {
    nodes {
      id
      name
      badgeName
      badgeColor
    }
  }
}
